module.exports = __webpack_public_path__ + "img/mobiledev.d29b5808.svg";